import { Amount } from '@model/common';
import { useI18NextContext } from '@components/hooks';
import { PerPerson, PriceLabelDefault } from '../../styles';
import React from 'react';
import styled from '@emotion/styled';
import { ThemeProps } from '@theme/base';

export interface PriceProps {
  amount: Amount;
}

const FromLabel = styled.span(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.labels.attribute as any),
  textTransform: 'none',
  paddingTop: 8,
  marginRight: theme.custom.spacing.xSmall
}));

export const Price = ({ amount }: PriceProps) => {
  const t: any = useI18NextContext();
  return (
    <>
      <FromLabel className={'global-hover'}>from </FromLabel>
      <PriceLabelDefault className={'global-hover'}>{amount.format()}</PriceLabelDefault>
      <PerPerson className={'global-hover'}>{t('common__label--per-person-short')}</PerPerson>
    </>
  );
};
